import type { ReactNode } from "react";

export const LIBRARY_TOOLBAR_CONTROL_CLASS = "h-12 rounded-xl px-3 text-sm";

/** Shared Library controls: compact filters and a prominent responsive search surface. */
export function LibraryToolbar({
  filters,
  search,
  actions,
}: {
  filters?: ReactNode;
  search?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div
      className="flex w-full min-w-0 flex-wrap items-center gap-2"
      data-testid="library-toolbar"
    >
      {filters ? (
        <div className="flex min-w-0 flex-wrap items-center gap-2">
          {filters}
        </div>
      ) : null}
      <div className="flex w-full min-w-0 flex-[1_1_480px] items-center gap-3 sm:max-w-[640px]">
        {search}
        {actions ? <div className="shrink-0">{actions}</div> : null}
      </div>
    </div>
  );
}
